import { useTranslation } from "react-i18next";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";

const Bar = ({ width, height = 14, className = "" }) => (
	<span className={`hibob-skeleton ${className}`} style={{ width, height }} />
);

/** Placeholder tiles and rows while the first status loads. */
function Skeleton() {
	const { t } = useTranslation();
	return (
		<div role="status" aria-busy="true" aria-label={t("hibob-loading")} data-testid="hibob-skeleton">
			<Card>
				<CardBody className="d-flex align-items-center">
					<Bar width={48} height={48} />
					<div className="ml-3 flex-grow-1">
						<Bar width={160} height={20} />
						<Bar width={260} className="mt-2" />
					</div>
				</CardBody>
			</Card>
			<Row>
				{[0, 1, 2, 3].map((i) => (
					<Col xs="6" lg="3" key={i}>
						<Card className="hibob-tile">
							<CardBody>
								<Bar width="60%" height={12} />
								<Bar width="70%" height={22} className="mt-3" />
								<Bar width="50%" height={12} className="mt-2" />
							</CardBody>
						</Card>
					</Col>
				))}
			</Row>
			<Row>
				<Col lg="8">
					<Card>
						<CardHeader>
							<Bar width={120} height={16} />
						</CardHeader>
						<CardBody>
							{[0, 1, 2, 3, 4].map((i) => (
								<Bar key={i} width="100%" height={18} className={i ? "mt-3" : ""} />
							))}
						</CardBody>
					</Card>
				</Col>
				<Col lg="4">
					<Card>
						<CardHeader>
							<Bar width={180} height={16} />
						</CardHeader>
						<CardBody>
							{[0, 1, 2, 3].map((i) => (
								<Bar key={i} width="90%" height={14} className={i ? "mt-3" : ""} />
							))}
						</CardBody>
					</Card>
				</Col>
			</Row>
			<span className="sr-only">{t("hibob-loading")}</span>
		</div>
	);
}

export default Skeleton;
